<!-- TODO: Add track link attributes -->
<div class="dealer-info-standard-map">
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="dealer-info-pane js-dealer-info-pane" tabindex="-1">
        <div class="dealer-info-standard" *ngIf="dealer">
          <div class="gb-body1 heavy" role="heading" aria-level="3">
            <p class="mb-0">{{dealer.name}}</p>
          </div>
          <ul class="mb-0">
            <li class="mb-0">
              <div class="gb-body2">
                <p class="mb-0">{{dealer.street}}</p>
              </div>
            </li>
            <li class="mb-0">
              <div class="gb-body2">
                <p class="mb-0">{{dealer.city}}, {{dealer.state}}</p>
              </div>
            </li>
            <li class="mb-0">
              <div class="gb-body2">
                <p class="mb-0">{{dealer.zipCode}}</p>
              </div>
            </li>
          </ul>

          <hr class="light">

          <div class="margin-bottom-large">
            <ul class="mb-6">
              <li class="mb-2" *ngIf="cmsPrefix">
                <div class="heavy gb-body2">
                  <p class="mb-0"[translate]="cmsPrefix+'_dealer_salesPhoneLabel'"></p>
                </div>
                <div class="gb-body2">
                  <a class="noWrap"
                    [href]="'tel:+'+dealer.salesPhone"
                    oxTrackLink
                    [trackLink]="trackLinkPrefix+': Sales Phone Number'"
                    [trackDelay]="'true'"
                    [trackType]="'o'"
                    [prop10]="prop10Prefix+':link:sales phone number:'+dealer.name+':'+dealer.salesPhone">
                    {{dealer.salesPhone}}
                  </a>
                </div>
              </li>

              <li  class="mb-4" *ngIf="cmsPrefix">
                <div class="heavy gb-body2">
                  <p class="mb-0"[translate]="cmsPrefix+'_dealer_servicePhoneLabel'"></p>
                </div>
                <div class="gb-body2">
                  <a class="noWrap"
                    [href]="'tel:+' + dealer.servicePhone"
                    oxTrackLink
                    [trackLink]="trackLinkPrefix+': Service Phone Number'"
                    [trackDelay]="'true'"
                    [trackType]="'o'"
                    [prop10]="prop10Prefix+':link:service phone number:'+dealer.name+':'+dealer.servicePhone">
                    {{dealer.servicePhone}}
                  </a>
                </div>
              </li>
            </ul>

            <ul>
              <li class="gb-body2"
                  *ngIf="dealer.dealerWebSite"
                  oxTrackLink
                  [trackLink]="trackLinkPrefix+':DealerWebsite'"
                  [trackDelay]="'this'"
                  [trackType]="'e'"
                  [prop10]="prop10Prefix+':link:dealer website'">
                <a class="noWrap dealerWebsiteLink"
                   [href]="dealer.dealerWebSite"
                   disabled="!dealership.dealer.dealerWebSite"
                   aria-haspopup="dialog"
                   aria-expanded="false"
                   [attr.aria-label]="dealer.name + ('aoda_open_new_window_aria_label' | translate)">
                  <span *ngIf="cmsPrefix" [translate]="cmsPrefix+'_dealerWebsite'"></span>&nbsp;
                  <span role="presentation" class="icon-ui-newwindow"></span>
                </a>
              </li>
            </ul>
          </div>


          <div class="heavy gb-body2" *ngIf="cmsPrefix">
            <p class="mb-0" *ngIf="cmsPrefix" [translate]="cmsPrefix+'_dealer_specialtyServicesLabel'"></p>
          </div>
          <ul class="list-styled mb-0" *ngFor="let service of dealer.specialtyServices">
            <li class="mb-0">
              <div class="gb-body2">
                <p class="mb-0">{{service}}</p>
              </div>
            </li>
          </ul>


          <hr class="light">

          <div class="row mb-4">
            <div class="col-12 col-lg-6" oxTrackLink
                [trackLink]="trackLinkPrefix+':GetDirections'"
                [trackDelay]="'true'"
                [trackType]="'o'"
                [prop10]="prop10Prefix+':button:get directions'">
              <button class="gb-primary-button mb-2"
                      [translate]="cmsPrefix+'_directions_getDirectionsBtn'"
                      *ngIf="cmsPrefix"
                      (click)="goToDealerDirections()">
              </button>
            </div>

            <div class="col-12 col-lg-6" oxTrackLink
                [trackLink]="trackLinkPrefix+':PrintInfo'"
                [trackDelay]="'this'"
                [trackType]="'o'"
                [prop10]="prop10Prefix+':button:print info'">
              <button class="gb-secondary-button"
                      [translate]="cmsPrefix+'_printDealerInfoBtn'"
                      *ngIf="cmsPrefix"
                      (click)="printDealerInfo()">
              </button>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-12">
              <div class="gb-body1"
                  oxTrackLink
                  [trackLink]="trackLinkPrefix+':ScheduleService'"
                  [trackDelay]="'this'"
                  [trackType]="'e'"
                  [prop10]="prop10Prefix+':button:schedule service'">
                  <a class="noWrap" (click)="loadOss()">
                    <span class="icon-graphic-service"></span>&nbsp;
                    <span *ngIf="cmsPrefix" [translate]="cmsPrefix+'_scheduleServiceBtn'"></span>
                  </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <p class="text-center mb-1" *ngIf="isFirefox">
        <!-- aoda_firefox_map_message cms is not defined -->
        <span class="gb-body2" [translate]="'aoda_firefox_map_message'"></span>
      </p>
      <div class="dealer-map-canvas gray-stroke js-dealer-map-canvas"></div>
    </div>
  </div>
</div>
